/* ==========================================================================
   see-in-person.js
   ==========================================================================
   Renders the native "See it in person" block (configurator-see-in-person.liquid)
   in one of three layouts (a = lead / b = rows / c = collapsible), driven by:
     1. the showroom data already on the page  ([data-showroom-data] JSON,
        owned by showroom-layer.liquid — handle / shortName / address / hours),
     2. the live multi-location inventory app   (.iia-list-item rows) for which
        showroom physically has THIS variant on the floor right now.
   The app is kept on the page (hidden via .pcfg--hide-iia) only so it can be
   read; this block draws the clean markup. Re-renders on every variant change
   (the app rewrites its list, a MutationObserver re-reads it).
   No dependency on showroom-layer.js — self-contained.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__sipInit) return;
  window.__sipInit = true;

  var BOOT = Date.now();

  var TZ = 'America/Los_Angeles';
  var PIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s7-5.7 7-11a7 7 0 1 0-14 0c0 5.3 7 11 7 11z"/><circle cx="12" cy="10" r="2.4"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function shortAddr(a) {
    return String(a || '').split(',').map(function (x) { return x.trim(); })
      .filter(Boolean).slice(0, 2).join(', ');
  }
  function directionsUrl(a) {
    return 'https://www.google.com/maps/search/?api=1&query=' +
      encodeURIComponent('Seldens Designer Home Furnishings ' + a);
  }

  /* ---- showroom data (already rendered once by showroom-layer.liquid) ---- */
  function getData() {
    var el = document.querySelector('[data-showroom-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---- read the inventory app for which showroom has THIS variant ----
     Returns {handle:true} for showrooms physically holding the piece, or null
     when the app has not rendered yet (meaningfully different from "rendered,
     not here"). Warehouse = Fife = delivery, never a showroom to visit. */
  function readApp(rooms) {
    var items = document.querySelectorAll('.iia-list-item');
    if (!items.length) return null;
    var map = {};
    Array.prototype.forEach.call(items, function (item) {
      var titleEl = item.querySelector('.iia-title-text');
      if (!titleEl) return;
      var nameNode = titleEl.firstChild;
      var name = ((nameNode && nameNode.textContent) || titleEl.textContent || '').toLowerCase();
      if (name.indexOf('warehouse') !== -1) return;
      var handle = matchHandle(name, rooms);
      if (!handle) return;
      var ex = item.querySelector('.iia-extra-text');
      var cls = (ex && ex.className) || '';
      var txt = ((ex && ex.textContent) || '').toLowerCase();
      var here = /on-display|in-stock/.test(cls) || /on display|in stock/.test(txt);
      if (here) map[handle] = true;
      else if (!(handle in map)) map[handle] = false;
    });
    return map;
  }
  function matchHandle(name, rooms) {
    var n = name.replace(/\bshowroom\b/g, '').replace(/[^a-z]/g, '');
    for (var i = 0; i < rooms.length; i++) {
      var h = String(rooms[i].handle || '').toLowerCase().replace(/[^a-z]/g, '');
      var sn = String(rooms[i].shortName || '').toLowerCase().replace(/[^a-z]/g, '');
      if (h && n.indexOf(h) !== -1) return rooms[i].handle;
      if (sn && n.indexOf(sn) !== -1) return rooms[i].handle;
    }
    return null;
  }

  function statusFor(handle, appMap) {
    return (appMap && appMap[handle]) ? 'this' : 'visit';
  }

  /* ---- "Open till 6pm" from the per-day hours JSON (store-local time) ---- */
  function toMin(s) { var p = String(s).trim().split(':'); return (+p[0]) * 60 + (+(p[1] || 0)); }
  function pretty(m) {
    var h = Math.floor(m / 60), mm = m % 60, ap = h < 12 ? 'am' : 'pm', hh = h % 12;
    if (hh === 0) hh = 12;
    return hh + (mm ? (':' + (mm < 10 ? '0' : '') + mm) : '') + ap;
  }
  function openTill(hours) {
    if (!hours) return '';
    if (typeof hours === 'string') { try { hours = JSON.parse(hours); } catch (e) { return ''; } }
    try {
      var now = new Date();
      var day = new Intl.DateTimeFormat('en-US', { timeZone: TZ, weekday: 'short' })
        .format(now).toLowerCase().slice(0, 3);
      var span = hours[day];
      if (!span || span.indexOf('-') === -1) return '';
      var parts = span.split('-');
      var openM = toMin(parts[0]), closeM = toMin(parts[1]);
      var hm = new Intl.DateTimeFormat('en-US', { timeZone: TZ, hour: '2-digit', minute: '2-digit', hour12: false }).format(now);
      var nowM = toMin(hm.replace(/[^0-9:]/g, ''));
      if (nowM >= openM && nowM < closeM) return 'Open till ' + pretty(closeM);
      if (nowM < openM) return 'Opens ' + pretty(openM);
      return 'Closed now';
    } catch (e) { return ''; }
  }

  /* ---- layout renderers ---- */
  function rowHtml(r) {
    var pill = r._status === 'this'
      ? '<span class="sip__pill sip__pill--this">On display</span>'
      : '<span class="sip__pill sip__pill--visit">Visit to order</span>';
    return '<a class="sip__row" href="' + directionsUrl(r.address) + '" target="_blank" rel="noopener" ' +
      'aria-label="Directions to the ' + esc(r.shortName) + ' showroom">' +
      '<span class="sip__pin">' + PIN + '</span>' +
      '<span class="sip__name">' + esc(r.shortName) + ' Showroom</span>' + pill +
      '<span class="sip__addr">' + esc(shortAddr(r.address)) + '</span></a>';
  }
  function dirTarget(rooms) {
    var here = rooms.filter(function (r) { return r._status === 'this'; })[0];
    return here || rooms[0];
  }

  function renderLead(rooms, showHours) {
    var here = rooms.filter(function (r) { return r._status === 'this'; });
    if (here.length) {
      var r = here[0];
      var hrs = showHours ? openTill(r.hours) : '';
      var rest = rooms.filter(function (x) { return x.handle !== r.handle; })
        .map(function (x) { return esc(x.shortName); });
      return '<div class="sip__lead"><span class="sip__pin">' + PIN + '</span><div class="sip__lead-b">' +
        '<div class="sip__headline">On display now at our <b>' + esc(r.shortName) + ' showroom</b></div>' +
        '<div class="sip__sub">' + esc(shortAddr(r.address)) + (hrs ? ' · ' + hrs : '') + '</div>' +
        '<div class="sip__acts"><a class="sip__lnk" href="' + directionsUrl(r.address) + '" target="_blank" rel="noopener">Get directions ›</a></div>' +
        '</div></div>' +
        (rest.length ? '<div class="sip__more">Also on our floors — ' + rest.join(' &amp; ') + '</div>' : '');
    }
    return '<div class="sip__lead"><span class="sip__pin">' + PIN + '</span><div class="sip__lead-b">' +
      '<div class="sip__headline">See this piece at a <b>Seldens showroom</b></div>' +
      '<div class="sip__sub">' + rooms.map(function (x) { return esc(x.shortName); }).join(' · ') + '</div>' +
      '<div class="sip__acts"><a class="sip__lnk" href="' + directionsUrl(dirTarget(rooms).address) + '" target="_blank" rel="noopener">Get directions ›</a></div>' +
      '</div></div>';
  }

  function renderRows(rooms) {
    return rooms.map(rowHtml).join('');
  }

  function renderCollapse(rooms) {
    var here = rooms.filter(function (r) { return r._status === 'this'; })[0];
    var sumT = here ? 'On display at ' + esc(here.shortName) : 'See it in person';
    return '<details class="sip__acc"><summary class="sip__acc-sum"><span class="sip__pin">' + PIN + '</span>' +
      '<span class="sip__acc-txt"><span class="sip__acc-t">' + sumT + '</span>' +
      '<span class="sip__acc-s">See all three showrooms</span></span>' +
      '<span class="sip__acc-caret" aria-hidden="true"></span></summary>' +
      '<div class="sip__acc-body">' + rooms.map(rowHtml).join('') + '</div></details>';
  }

  function render(root) {
    var data = root.__sipData || getData();
    if (!data || !data.showrooms || !data.showrooms.length) return;
    root.__sipData = data;

    var rooms = data.showrooms.slice();
    var appMap = readApp(rooms);
    rooms.forEach(function (r) {
      r._status = statusFor(r.handle, appMap);
      r._k = (r._status === 'this' ? 0 : 100) + (r.sortOrder || 0);
    });
    rooms.sort(function (a, b) { return a._k - b._k; });

    /* Hide the whole block when the piece is on NO showroom floor — i.e. the
       inventory app has reported (appMap !== null) and every room is "Visit",
       nothing on display or in stock. "See it in person" overpromises on a
       special-order piece you cannot actually see anywhere. While the app has
       not rendered yet (appMap === null) the block stays up, so a slow or
       failed app never hides a working fallback. Opt out per block with the
       "Hide when not on display anywhere" setting (data-sip-hide-empty). */
    var blockEl = (root.closest && root.closest('.pcfg__block')) || root;
    if (root.getAttribute('data-sip-hide-empty') !== 'false') {
      var anyHere = false;
      for (var hi = 0; hi < rooms.length; hi++) {
        if (rooms[hi]._status === 'this') { anyHere = true; break; }
      }
      /* Hide the whole block once we can trust "nothing on display": either the
         app rendered its rows and none are on the floor (appMap !== null), OR
         the app has had time to run (BOOT + ~700ms) and its container is still
         empty — a piece carried at no location renders no rows at all. Until
         then the block stays up, so a slow/failed app never hides a working
         fallback. (All three showrooms, with their On display / Visit status,
         still show whenever at least one is on the floor.) */
      if (!anyHere) {
        var appBox = document.getElementById('inventory-info-app') || document.querySelector('.iia-container');
        if (appMap !== null || ((Date.now() - BOOT) > 700 && appBox)) {
          blockEl.style.display = 'none';
          return;
        }
      }
    }
    blockEl.style.display = '';

    var layout = root.getAttribute('data-sip-layout') || 'a';
    var showHours = root.getAttribute('data-sip-hours') !== 'false';
    var mount = root.querySelector('[data-sip-mount]');
    if (!mount) return;

    // Preserve the open state of layout C across re-renders.
    var wasOpen = false;
    var openEl = mount.querySelector('.sip__acc');
    if (openEl) wasOpen = openEl.hasAttribute('open');

    if (layout === 'b') mount.innerHTML = renderRows(rooms);
    else if (layout === 'c') mount.innerHTML = renderCollapse(rooms);
    else mount.innerHTML = renderLead(rooms, showHours);

    if (layout === 'c' && wasOpen) {
      var acc = mount.querySelector('.sip__acc');
      if (acc) acc.setAttribute('open', '');
    }
    root.setAttribute('data-sip-ready', '');
  }

  function renderAll() {
    var roots = document.querySelectorAll('[data-sip]');
    Array.prototype.forEach.call(roots, render);
  }

  function watch() {
    var host = document.querySelector('#inventory-info-app') || document.querySelector('.iia-container');
    if (host) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(renderAll, 120);
      }).observe(host, { childList: true, subtree: true, characterData: true });
    }
  }

  function boot() {
    if (!document.querySelector('[data-sip]')) return;
    renderAll();
    watch();
    // The inventory app renders client-side ~200ms after load; catch it. The
    // later passes also let the "app stayed empty → hide" check settle.
    setTimeout(renderAll, 400);
    setTimeout(renderAll, 900);
    setTimeout(renderAll, 1600);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
